import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { configureAuth0TokenGetters } from "@/services/auth0-token";

export function Auth0SessionBridge() {
  const {
    error,
    getIdTokenClaims,
    getAccessTokenSilently,
    isAuthenticated,
    isLoading,
    user,
  } = useAuth0();

  useEffect(() => {
    configureAuth0TokenGetters({ getIdTokenClaims, getAccessTokenSilently });
    return () => configureAuth0TokenGetters(null);
  }, [getAccessTokenSilently, getIdTokenClaims]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("code") || params.has("state") || error) {
      console.info("[Auth0] session state", {
        hasCode: params.has("code"),
        hasState: params.has("state"),
        isLoading,
        isAuthenticated,
        userSub: user?.sub,
        error: error
          ? {
              name: error.name,
              message: error.message,
            }
          : null,
      });
    }
  }, [error, isAuthenticated, isLoading, user?.sub]);

  return null;
}
